import React, { useEffect, useState } from 'react';
import { Activity, ActivityType } from '../../types';
import { fetchActivities } from '../../services/api';

interface Props {
  subjectType: 'leads' | 'deals';
  subjectId: number;
  compact?: boolean;
}

const iconMap: Record<ActivityType, string> = {
  created:        '✦',
  updated:        '✎',
  note_added:     '📝',
  task_added:     '☑',
  task_completed: '✔',
  status_changed: '⇄',
  stage_changed:  '⇄',
  voice_call:     '📞',
  assigned:       '👤',
};

const classMap: Record<ActivityType, string> = {
  created:        'activity-icon-created',
  updated:        'activity-icon-updated',
  note_added:     'activity-icon-note',
  task_added:     'activity-icon-task',
  task_completed: 'activity-icon-task',
  status_changed: 'activity-icon-status',
  stage_changed:  'activity-icon-status',
  voice_call:     'activity-icon-call',
  assigned:       'activity-icon-status',
};

const ActivityFeed: React.FC<Props> = ({ subjectType, subjectId, compact }) => {
  const [activities, setActivities] = useState<Activity[]>([]);

  useEffect(() => {
    fetchActivities(subjectType, subjectId).then(setActivities);
  }, [subjectType, subjectId]);

  const formatTime = (iso: string) =>
    new Date(iso).toLocaleString(undefined, {
      month: 'short', day: 'numeric', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    });

  const list = compact ? activities.slice(0, 3) : activities;

  return (
    <div className="activity-feed">
      {list.length === 0 && (
        <p className="detail-info-empty">No activity yet.</p>
      )}
      {list.map((a) => (
        <div className="activity-item" key={a.id}>
          <div className={`activity-icon ${classMap[a.type] ?? ''}`}>
            {iconMap[a.type] ?? '•'}
          </div>
          <div className="activity-body">
            <div className="activity-desc">{a.description}</div>
            <div className="activity-meta">
              {a.user?.name && <span>{a.user.name}</span>}
              <span>{formatTime(a.created_at)}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActivityFeed;
